import { Box, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

export const SlotsTable = () => {
  const data = Array(4).fill('');
  return (
    <TableContainer component={Box}>
      <Table
        sx={{
          '.MuiSkeleton-root': { display: 'inline-block', height: '25.75px' },
          'th .MuiSkeleton-root': { height: '25px' },
          '.MuiSkeleton-rounded': { borderRadius: '1000px' },
          'td, th': { verticalAlign: 'middle' },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>
              <Skeleton variant="rectangular" width={110} />
            </TableCell>
            <TableCell align="right">
              <Skeleton variant="rectangular" width={110} />
            </TableCell>
            <TableCell align="right" sx={{ width: 104, px: 1.5 }}>
              <Skeleton variant="rounded" width={60} />
            </TableCell>
            <TableCell align="right" sx={{ width: 116, px: 1.5 }}>
              <Skeleton variant="rounded" width={60} />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((_, idx) => (
            <TableRow key={idx}>
              <TableCell colSpan={2}>
                <Skeleton variant="rectangular" width={110} />
              </TableCell>
              <TableCell align="right" sx={{ width: 104, px: 1.5 }}>
                <Skeleton variant="rounded" width={70} />
              </TableCell>
              <TableCell align="right" sx={{ width: 116, px: 1.5 }}>
                <Skeleton variant="rounded" width={70} />
              </TableCell>
              <TableCell align="right" sx={{ width: 160 }}>
                <Skeleton variant="rectangular" width={97} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
